import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['checkbox', 'options']

  connect() {
    this.toggle()
  }

  toggle() {
    if (this.checkboxTarget.checked) {
      this.optionsTarget.classList.remove('hidden')
    } else {
      this.optionsTarget.classList.add('hidden')
    }
  }
}
